import { PdfCell } from './pdf-cell';
import { PdfColDef } from './pdf-col-def';
import { PdfRow } from './pdf-row';

export class PdfTable {

    headerRows: number;
    widths: string[];
    style: string;
    body: any[];

    constructor(pdfColDefs: PdfColDef[], data: string[][]) {
        this.body = [];

        this.widths = [];
        let headers = [];
        pdfColDefs.forEach(colDef => {
            this.widths.push(colDef.width);
            headers.push(colDef.header);
        });
        this.addHeaders(headers);

        data.forEach(rowData => {
            let row = new PdfRow();
            for (let i = 0; i < rowData.length; i++) {
                row.addCell(new PdfCell(rowData[i], pdfColDefs[i].type));
            }
            this.addRow(row);
        });

    }

    addHeaders(headersParam: string[]) {
        if (headersParam) {
            let headersRow = [];
            headersParam.forEach(header => {
                headersRow.push({ text: header, style: 'headerCell' });
            });
            this.body.push(headersRow);
        }
    }

    addRow(row: PdfRow) {
        this.body.push(row.pdfCells);
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/pdf/pdf-table.ts